'use client';
import React from 'react';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { getBreadcrumbSchema } from '../seo/TypesSchema';
export default function BreadCrumb({
  type,
  breadcrumb,
  objectTitle,
  objectLink,
}) {
  const searchParams = useSearchParams();
  return (
    <>
      <section>
        <script
          id="app-ld-json"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              getBreadcrumbSchema(breadcrumb, objectTitle, type)
            ),
          }}
        />
      </section>

      <div className="spBreadCrumb py-6 text-xs text-gray-300 whitespace-nowrap overflow-y-auto">
        <nav className="">
          <Link className="breadcrumb-link pl-2" href="/">
            برقچی
          </Link>
          /
          {breadcrumb &&
            breadcrumb
              .slice(0)
              .reverse()
              .map((item, index) => (
                <React.Fragment key={index}>
                  <Link
                    className="breadcrumb-link px-2 "
                    href={`/${
                      type == 'brand' || (type == 'brandCategory' && index == 0)
                        ? ''
                        : type == 'brandCategory'
                        ? 'brand'
                        : 'cat'
                    }${item.link}`}
                  >
                    {item.title}
                  </Link>
                  /
                </React.Fragment>
              ))}
          {objectLink &&
          searchParams.get('page') &&
          searchParams.get('page') != 1 ? (
            <Link href={type ? `/${type}${objectLink}` : `/${objectLink}`}>
              <span className="breadcrumb-last px-2">{objectTitle}</span>
            </Link>
          ) : (
            <span className="breadcrumb-last px-2">{objectTitle}</span>
          )}
          {searchParams.get('page') && searchParams.get('page') != 1 && (
            <span>{` / صفحه ${searchParams.get('page')}`}</span>
          )}
        </nav>
      </div>
    </>
  );
}
